module.exports = __webpack_public_path__ + "static/monkey-phone-8277829ee09afe9b38324c61151bf429.svg";